import React from "react";
import classes from "./RequestDemoButton.module.css";

const RequestDemoButton = ({ onClick, className, isOpen, ...props }) => {
  return (
    <button
      className={[
        classes.button,
        isOpen ? classes.opening : "",
        className,
      ].join(" ")}
      onClick={onClick}
      {...props}
    >
      <span className={classes.icon}>?</span>
      <span>REQUEST A DEMO</span>
    </button>
  );
};

export default RequestDemoButton;
